import { UnauthApiClient } from "./apiclient";

export default class SearchService extends UnauthApiClient {
  async query(params, page, isFilter = false) {
    let url = `/search/contents?contentType=${params.contentType}&searchData=${params.query}`;
    return this.GET(url);
  }

  async searchFiltered(params) {
    return this.GET(`/search/contents?filters=[${params.filters}]&contentType=${params.contentType}&aux=`);
  }
}
